import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { DropdownMenu } from 'seagull';
import { DoorEnter } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { useClientView } from '~/hooks/useClientView';
import { useLocaleKeys } from '~/i18n';
export const GetClientViewMenuItemTID = (parentTestId)=>getTestIds(parentTestId);
export default function ClientViewMenuItem(param) {
    let { clientBusinessId, viewUserId, disabled, disabledTooltip, testId, onClick } = param;
    const { t: clientViewTexts } = useLocaleKeys('client.view');
    const { startClientView } = useClientView();
    const { ClientViewMenuItemTestIds } = useMemo(()=>GetClientViewMenuItemTID(testId), [
        testId
    ]);
    const isDisabled = disabled || clientBusinessId == null;
    function dismissMenuAndStartClientView(event, biCallerContext) {
        if (clientBusinessId == null) {
            return;
        }
        onClick === null || onClick === void 0 ? void 0 : onClick(event, biCallerContext);
        startClientView(clientBusinessId, viewUserId);
    }
    return /*#__PURE__*/ _jsx(DropdownMenu.Item, {
        iconStart: /*#__PURE__*/ _jsx(DoorEnter, {}),
        onClick: dismissMenuAndStartClientView,
        disabled: isDisabled,
        tooltipProps: isDisabled && disabledTooltip != null ? {
            title: disabledTooltip,
            placement: 'top'
        } : undefined,
        testId: ClientViewMenuItemTestIds.Root(),
        bi: {
            name: 'view-client-portal-menu-item'
        },
        children: clientViewTexts.menuItem()
    });
}
